import { useForm } from '@inertiajs/react'

import { TextInput } from '@atoms'
import Link from '@components/atoms/Link'
import { ConfigurationsLayout } from '@components/configurations/ConfigurationsLayout'
import { SettingsCard } from '@components/configurations/SettingsCard'
import { SettingsForm, textField } from '@components/configurations/SettingsForm'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('configurations.sms')

export type SmsShowProps = {
  platform: 'Twilio' | 'Plivo'
  values: Record<string, string>
}

const CONSOLES = { Twilio: 'https://console.twilio.com/', Plivo: 'https://console.plivo.com/' }
const PHONE_NUMBERS = ['TWILIO_NUMBER_FOR_CALLS', 'PLIVO_MOBILE_NUMBER']

export default function SmsShow({ platform, values }: SmsShowProps) {
  const form = useForm(values)

  return (
    <ConfigurationsLayout>
      <SettingsCard heading={platform}>
        <SettingsForm form={form} action="/app/settings/sms">
          <div className="tw:flex tw:flex-col tw:gap-1">
            <p className="tw:m-0 tw:text-sm tw:text-gray-cool-700">{t('intro', { platform })}</p>
            <Link
              href={CONSOLES[platform]}
              target="_blank"
              rank="link"
              size="sm"
              trailingIcon="external-link"
              className="tw:p-0"
            >
              {t('console_link', { platform })}
            </Link>
          </div>
          {Object.keys(values).map((key) => (
            <TextInput
              key={key}
              label={t(`fields.${key}`)}
              {...(PHONE_NUMBERS.includes(key) && { type: 'tel', description: t('number_hint') })}
              {...textField(form, key)}
            />
          ))}
        </SettingsForm>
      </SettingsCard>
    </ConfigurationsLayout>
  )
}
